import { useState } from "react";
import { GridColDef, GridPinnedColumnFields } from "@mui/x-data-grid-pro";

export const useResizableColumns = (columns: GridColDef[]) => {
  const [columnState, setColumnState] = useState<GridColDef[]>(columns);
  const [pinnedColumns, setPinnedColumns] = useState<GridPinnedColumnFields>({
    right: ["actions"],
  });

  const handleColumnResize = (newWidth: number, colDef: GridColDef) => {
    setColumnState((prev) =>
      prev.map((col) => {
        if (col.field !== colDef.field) return col;
        const updated: GridColDef = { ...col, width: newWidth } as GridColDef;
        updated.flex = undefined;
        return updated;
      })
    );
  };

  return {
    columnState,
    setColumnState,
    pinnedColumns,
    setPinnedColumns,
    handleColumnResize,
  };
};